export class Urls {
  public static ROLES_ENDPOINT = '/subscriptions/api/users/authorized_roles?reach_users=true'
  public static STATUS_ENDPOINT = '/subscriptions/api/users/authorized_status'
}
